import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import CollarBonePiercingImage from '../../Assets/Piercing Services/color born piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function CollarBonePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Collarbone Piercing UAE | 450 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Collarbone Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Collarbone Piercing 450 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={CollarBonePiercingImage} alt="Collarbone Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Collarbone Piercing</h3>

          <p>
            Enhance your body aesthetics with our professional collarbone piercing services in the UAE, available at a premium price of 450 AED. Collarbone piercing is an eye-catching and elegant surface piercing placed along the collarbone area, designed to beautifully showcase jewelry and highlight your natural features. This stylish and modern piercing creates a stunning visual effect, making it a perfect choice for individuals who want to express their personality with confidence and sophistication. Whether you prefer sleek surface bars, sparkling dermal tops, or decorative designs, collarbone piercing offers a versatile and fashionable way to elevate your look.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each collarbone piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Surface piercings like the collarbone require specialized expertise, and our experienced specialists are trained to ensure proper placement, alignment, and depth for long-lasting and aesthetically pleasing results while minimizing discomfort.
          </p>

          <p>
            Collarbone piercing is ideal for individuals who want a bold yet elegant body modification that stands out beautifully. Its placement along the collarbone creates a flattering and eye-catching effect, especially when paired with the right jewelry. This piercing can be worn as a single piece for a subtle look or as multiple piercings for a more dramatic and customized design. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your body structure and personal style.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic surface jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that surface piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for collarbone piercings due to their placement and exposure to movement and clothing. We provide detailed instructions to help you maintain proper care during the healing period, including cleaning routines, recommended products, and precautions to avoid irritation, friction, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our collarbone piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive excellent value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted collarbone piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a stylish and elegant body look effortlessly. Book your collarbone piercing appointment today and showcase your jewelry with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Collarbone Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CollarBonePiercing;